export const PHASES = [
  {
    n: "01",
    title: "Online Business Foundation",
    items: [
      "How online businesses generate revenue",
      "B2C, D2C, marketplaces and service businesses",
      "Understanding customers and their problems",
      "Business-model selection",
      "Revenue, cost, margin and profit fundamentals",
    ],
  },
  {
    n: "02",
    title: "Market and Product Research",
    items: [
      "Market research",
      "Customer profiling",
      "Competitor analysis",
      "Product and niche research",
      "Demand validation",
      "Identifying market gaps",
      "Selecting products or services using data",
    ],
  },
  {
    n: "03",
    title: "Business Economics",
    items: [
      "Product or service costing",
      "Selling-price calculation",
      "Gross margin",
      "Contribution margin",
      "Customer acquisition cost",
      "Shipping and payment expenses",
      "Returns and RTO allocation",
      "Break-even calculation",
      "Cash-flow planning",
      "Net-profit calculation",
    ],
  },
  {
    n: "04",
    title: "Branding and Offer Creation",
    items: [
      "Brand positioning",
      "Business and brand naming",
      "Target-customer selection",
      "Value proposition",
      "Offer creation",
      "Product bundles",
      "Pricing psychology",
      "Guarantees and customer trust",
      "Packaging and visual presentation",
    ],
  },
  {
    n: "05",
    title: "Website and Landing-Page Building",
    items: [
      "Domain and website fundamentals",
      "Shopify store setup",
      "WordPress and WooCommerce introduction",
      "Website structure and navigation",
      "Product and service pages",
      "Landing pages",
      "Payment-gateway setup",
      "Shipping integration",
      "Mobile optimisation",
      "Conversion-focused website design",
    ],
  },
  {
    n: "06",
    title: "Content and Creative Production",
    items: [
      "Content strategy",
      "Advertising hooks",
      "Video scripts",
      "Product demonstrations",
      "Short-form videos and reels",
      "Advertising creatives",
      "Basic design principles",
      "Editing with mobile and desktop tools",
      "User-generated-content concepts",
      "Content calendars",
    ],
  },
  {
    n: "07",
    title: "Meta Advertising",
    featured: true,
    items: [
      "Meta Business Portfolio",
      "Facebook and Instagram advertising",
      "Campaign objectives",
      "Audience research",
      "Creative testing",
      "Lead-generation campaigns",
      "WhatsApp campaigns",
      "Website sales campaigns",
      "Meta Pixel and conversion tracking",
      "Retargeting",
      "Campaign optimisation",
      "Advertising budget and profitability",
    ],
  },
  {
    n: "08",
    title: "Google Advertising",
    items: [
      "Google Ads fundamentals",
      "Search campaigns",
      "Keyword research",
      "Search intent",
      "Advertisement copy",
      "Conversion tracking",
      "Display and remarketing introduction",
      "Google Shopping fundamentals",
      "Campaign optimisation",
      "Budget and performance analysis",
    ],
  },
  {
    n: "09",
    title: "Amazon and Flipkart",
    items: [
      "Seller-account fundamentals",
      "Product listing",
      "Search keywords",
      "Catalogue optimisation",
      "Marketplace advertising",
      "Order and inventory management",
      "Returns and customer feedback",
      "Fees and settlement reports",
      "Account-health management",
    ],
  },
  {
    n: "10",
    title: "E-Commerce Operations",
    items: [
      "Order processing",
      "COD and prepaid orders",
      "Order confirmation",
      "Shipping and courier management",
      "NDR follow-up",
      "RTO reduction",
      "Customer support",
      "Returns and refunds",
      "Inventory management",
      "Payment and courier reconciliation",
    ],
  },
  {
    n: "11",
    title: "Analytics and Business Diagnosis",
    featured: true,
    items: [
      "Revenue and orders",
      "Average order value",
      "Cost per lead",
      "Customer acquisition cost",
      "CPM, CTR and CPC",
      "Website conversion rate",
      "ROAS",
      "Delivered ROAS",
      "RTO percentage",
      "Gross margin",
      "Contribution margin",
      "Operating profit",
      "Net profit",
      "Business-performance dashboard",
    ],
  },
];
